"use client";

import { useState } from "react";
import { Check, Share2 } from "lucide-react";
import { cn } from "@/lib/utils";

// Een uitslag, wedstrijd, team of bericht doorsturen (B6).
//
// Op een telefoon opent dit het deelmenu van het toestel - WhatsApp, berichten,
// mail - want daar zit wie iets wil doorsturen al. Waar dat niet bestaat, op de
// meeste computers, kopiëren we de link en zeggen we dat.
//
// De vorm is die van de ster ernaast (favoriet-knop.tsx), zodat de twee als
// een paar lezen.

export function DeelKnop({ titel, tekst, groot }: { titel: string; tekst?: string; groot?: boolean }) {
  const [gekopieerd, setGekopieerd] = useState(false);

  async function deel() {
    // Zonder een #-anker, maar met de zoekparameters: ?tab=standen hoort bij
    // wat je deelt.
    const url = window.location.href.split("#")[0];
    if (navigator.share) {
      try {
        await navigator.share({ title: titel, text: tekst, url });
      } catch {
        // Weggetikt, of het toestel weigerde: niets aan de hand.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setGekopieerd(true);
      setTimeout(() => setGekopieerd(false), 2500);
    } catch {
      // Geen klembord (een oud of streng ingesteld toestel): laat de adresbalk
      // het werk doen.
      window.prompt("Kopieer deze link", url);
    }
  }

  return (
    <button
      type="button"
      onClick={deel}
      aria-label={gekopieerd ? "Link gekopieerd" : `${titel} delen`}
      title={gekopieerd ? "Link gekopieerd" : "Delen"}
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full border-2 transition-colors",
        groot ? "size-11" : "size-9",
        gekopieerd
          ? "border-primary bg-primary text-primary-foreground"
          : "border-white/25 text-white/60 hover:border-white/50 hover:text-white",
      )}
    >
      {gekopieerd ? (
        <Check className={groot ? "size-5" : "size-4"} strokeWidth={3} />
      ) : (
        <Share2 className={groot ? "size-5" : "size-4"} />
      )}
      <span className="sr-only" aria-live="polite">
        {gekopieerd ? "Link gekopieerd" : ""}
      </span>
    </button>
  );
}
